// extracted by mini-css-extract-plugin
export default {"message_container":"PageNotFound_message_container__YILuh","text":"PageNotFound_text__wv2h7"};